import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";

import { catchError, takeUntil } from "rxjs/operators";
import { interval, of, Subject } from "rxjs";

import { CoreConfigService } from "@core/services/config.service";
import { LogoService } from "../../../util/service/logo.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "../../../api/services/app.service";

@Component({
  selector: "app-offline",
  templateUrl: "./offline.component.html",
  styleUrls: ["./offline.component.scss"],
  standalone: false,
})
export class OfflineComponent implements OnInit, OnDestroy {
  public coreConfig: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param logoService
   * @param _route
   * @param router
   * @param appService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    public logoService: LogoService,
    private _route: ActivatedRoute,
    private router: Router,
    private appService: AppService
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  get returnUrl() {
    const returnUrl = this._route.snapshot.queryParams["returnUrl"] || "/";
    return returnUrl === "/error" ? "/" : returnUrl;
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    const isPageReload = sessionStorage.getItem("isPageReload");
    if (isPageReload === "true") {
      sessionStorage.setItem("isPageReload", "false");
      this.router.navigateByUrl(this.returnUrl);
    }

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      this.coreConfig = config;
    });

    interval(10000)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this.appService
          .appControllerApiHealthCheck()
          .pipe(
            catchError((error) => {
              return of(null);
            })
          )
          .subscribe((response) => {
            if (response?.online) {
              this.returnToRedirectUrl();
            }
          });
      });
  }

  @HostListener("window:beforeunload", ["$event"])
  beforeUnloadHandler(event: any) {
    sessionStorage.setItem("isPageReload", "true");
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  returnToRedirectUrl() {
    window.location.href = this.returnUrl;
  }
}
